import React from 'react';
import { Container } from 'react-bootstrap';

function PYear2 () {
    return (
        <div>
            <Container>
            <table class="table table-hover">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th colspan="2">Subject Name</th>
      <th scope="col">Download</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <th scope="row">1</th>
      <td colspan="2">MEFA</td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1EsTzVLrhvqa3suq5g5fwQ-ACmhJ5WCZv/view?usp=sharing' download> Download <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
        <th scope='row'>2</th>
        <td colspan="2">Discreate Mathematics Structure</td>
        <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1k8kBJejdL1gmPB-lJKpv-rb_VbtH11EQ/view?usp=sharing' download> Download <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">3</th>
      <td colspan="2">Microprocessor</td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1LB0cVBCxSKe09nEO2G94W_EYuzhQ_xXk/view?usp=sharing' download> Download <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">4</th>
      <td colspan="2">DBMS</td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1GaP1dqOR2V4y0_jOdBUp3ndmvbAOfU_C/view?usp=sharing' download> Download <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">5</th>
      <td colspan="2">TOC</td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1uP2qV1ECkilLfsGPVGFwsgw_9ERN3EMr/view?usp=sharing' download> Download <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">4</th>
      <td colspan="2">DCCN</td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1weQrMMOsHYNzZMK7PxH50vcqS3K5DG4_/view?usp=sharing' download> Download <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
  </tbody>
</table>
</Container>
        </div>
    );
}

export default PYear2;
